import { takeLatest, put } from 'redux-saga/effects'
import {
  getEmailTemplates,
  getEmailTemplate,
  updateEmailTemplate,
  createEmailTemplate,
  // primaryEmailTemplate,
  getImageGallery,
  deleteFromGallery,
  testEmailTemplateEndPoint,
  deleteEmailTemplateLanguage,
  getEmailTypes,
  primaryEmailTemplate,
  deleteEmailTemplate
} from '../../utils/apiCalls'
import {
  getAllemailTemplatesStart,
  getAllemailTemplatesComplete,
  getemailTemplateStart,
  getemailTemplateComplete,
  updateEmailTemplateStart,
  updateEmailTemplateComplete,
  createEmailTemplateStart,
  createEmailTemplateComplete,
  emailTemplateFailure,
  makePrimaryEmailTemplatesStart,
  makePrimaryEmailTemplatesComplete,
  getDynamicKeysStart,
  getDynamicKeysComplete,
  getImageGalleryStart,
  getImageGallerySuccess,
  getImageGalleryFailure,
  deleteFromGalleryStart,
  deleteFromGalleryComplete,
  testEmailTemplateStart,
  testEmailTemplateSuccess,
  testEmailTemplateFailure,
  deleteEmailTemplateLanguageStart,
  deleteEmailTemplateLanguageComplete,
  getEmailTypesStart,
  getEmailTypesSuccess,
  getEmailTypesFailure,
  deleteEmailTemplatesStart,
  deleteEmailTemplatesComplete
} from '../redux-slices/emailTemplate'
import { toast } from '../../components/Toast'
import { emailDynamicOptions } from '../../pages/Tenant/EmailTemplate/Constant'

export default function* EmailTemplateWatcher() {
  yield takeLatest(getAllemailTemplatesStart.type, getAllemailTemplatesWorker)
  yield takeLatest(getemailTemplateStart.type, getemailTemplateWorker)
  yield takeLatest(updateEmailTemplateStart.type, updateEmailTemplateWorker)
  yield takeLatest(createEmailTemplateStart.type, createEmailTemplateWorker)
  yield takeLatest(makePrimaryEmailTemplatesStart.type, primaryEmailTemplateWorker)
  yield takeLatest(deleteEmailTemplatesStart.type, deleteTemplateWorker)
  yield takeLatest(getDynamicKeysStart.type, getDynamicKeysWorker)
  yield takeLatest(getImageGalleryStart.type, getImageGalleryWorker)
  yield takeLatest(deleteFromGalleryStart.type, deleteFromGalleryWorker)
  yield takeLatest(testEmailTemplateStart.type, testEmailTemplateWorker)
  yield takeLatest(deleteEmailTemplateLanguageStart.type, deleteEmailTemplateLanguageWorker)
  yield takeLatest(getEmailTypesStart.type, getEmailTypesWorker)
}

function* getAllemailTemplatesWorker(action) {
  try {
    const { isTenant = false } = action && action.payload
    const { data } = yield getEmailTemplates({ isTenant })
    yield put(getAllemailTemplatesComplete(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}

function* getDynamicKeysWorker(action) {
  try {
    const { type, emailTypes } = action && action.payload
    const data = yield emailDynamicOptions({ type, emailTypes })
    yield put(getDynamicKeysComplete(data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}

function* getemailTemplateWorker(action) {
  try {
    const { emailTemplateId, isTenant = false, tenantId = '' } = action && action.payload

    const { data } = yield getEmailTemplate({ emailTemplateId, isTenant, tenantId: tenantId || '' })

    yield put(getemailTemplateComplete(data?.data?.emailTemplate))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}

function* updateEmailTemplateWorker(action) {
  try {
    const { data, isTenant = false } = action && action.payload
    yield updateEmailTemplate({ data, isTenant })

    data?.create
      ? yield toast('Template Created Successfully', 'success')
      : yield toast('Template Updated Successfully', 'success')
    yield put(updateEmailTemplateComplete())
    yield put(getemailTemplateStart({ emailTemplateId: data?.emailTemplateId, isTenant, tenantId: data?.tenantId }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}
function* primaryEmailTemplateWorker(action) {
  try {
    const { data } = action && action.payload
    yield primaryEmailTemplate({ data })

    yield toast('Template Marked As Primary Successfully', 'success')
    yield put(getAllemailTemplatesStart({ isTenant: true }))
    yield put(makePrimaryEmailTemplatesComplete())
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}

function* deleteTemplateWorker(action) {
  try {
    const { data } = action && action.payload
    yield deleteEmailTemplate({ data })

    yield toast('Template Deleted Successfully', 'success')
    yield put(getAllemailTemplatesStart({ isTenant: true }))
    yield put(deleteEmailTemplatesComplete())
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}


function* createEmailTemplateWorker(action) {
  try {
    const { data, isTenant } = action && action.payload
    const res = yield createEmailTemplate({ data, isTenant })

    yield toast('Template Created Successfully', 'success')
    yield put(createEmailTemplateComplete())
    yield put(getemailTemplateStart({ isTenant, emailTemplateId: res?.data?.data?.emailTemplate?.emailTemplateId, tenantId: data?.tenantId || '' }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(emailTemplateFailure())
  }
}

function* getImageGalleryWorker(action) {
  try {
    const { isTenant = false } = action && action.payload
    const { data } = yield getImageGallery(isTenant)
    yield put(getImageGallerySuccess(data?.data?.gallery))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')
    yield put(getImageGalleryFailure())
  }
}

function* deleteFromGalleryWorker(action) {
  try {
    const { isTenant = false, data } = action && action.payload
    yield deleteFromGallery({ isTenant, data })
    yield put(deleteFromGalleryComplete())
    toast('Image Deleted Successfully', 'success')
    yield put(getImageGalleryStart({ isTenant }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')
    yield put(deleteFromGalleryComplete())
  }
}

function* testEmailTemplateWorker(action) {
  try {
    const { isTenant, data, setIsTestTemplateModalVisible, setTestEmail } = action && action.payload
    const res = yield testEmailTemplateEndPoint({ isTenant, data })
    yield put(testEmailTemplateSuccess())
    setIsTestTemplateModalVisible(false)
    setTestEmail('')
    res?.data?.data?.emailSent?.success
      ? yield toast('Email Sent Successfully', 'success')
      : yield toast('Email Sending Unsuccessful', 'error')
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(testEmailTemplateFailure())
  }
}

function* deleteEmailTemplateLanguageWorker(action) {
  try {
    const { isTenant, data } = action && action.payload

    yield deleteEmailTemplateLanguage({ isTenant, data })

    yield put(deleteEmailTemplateLanguageComplete())

    yield toast('Email Template Deletion Successful', 'success')
    yield put(getemailTemplateStart({ emailTemplateId: data?.emailTemplateId, isTenant }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(deleteEmailTemplateLanguageComplete())
  }
}

function* getEmailTypesWorker(action) {
  try {
    const { isTenant } = action && action.payload
    const { data } = yield getEmailTypes({ isTenant })
    yield put(getEmailTypesSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')
    yield put(getEmailTypesFailure())
  }
}
